const siteConfig = {
  brandName: "domtanion",
  displayName: "domtanion",
  website: "https://www.domtanion.art",
  companyName: "WAISION TECHNOLOGY DEVELOPMENT LIMITED",
  description:
    "Broeken voor elke dag, met aandacht voor pasvorm, kleur en detail.",
  currency: "EUR",
  currencySymbol: "€",
  freeShippingThreshold: 250,
  standardShipping: 8,
  contact: {
    email: "force@domtanion.art",
    address: "UNIT 05, 12/F, THE CLOUD,NO.111 TUNG CHAU STREET, TAI,KOK TSUI",
  },
  social: {},
};

export const formatPrice = (value) =>
  new Intl.NumberFormat("nl-BE", {
    style: "currency",
    currency: siteConfig.currency,
    minimumFractionDigits: 0,
  }).format(value);

export default siteConfig;
